import type { SiteProfile } from './types';

export const wognumProfile: SiteProfile = {
  id: 'wognum',
  name: 'Wognum Energy Park',
  company: 'Greenvision Charging',
  client: 'Simon Loos',
  logoUrl: undefined,
  clientLogoUrl: undefined,
  password: undefined, // No password in CRM context
  version: 'v1.3',

  solarProfile: [
    [1.4,0.9,0.4,0.5,1.3,2.7,6.1,8.1,10.1,254.3,1305.6,2707.5,3249.4,3074.1,2196.3,909.8,121.9,3.2,3.9,6,7.9,6.1,3.8,1.9],
    [.8,.3,0,0,.5,1.3,2.9,6,256.2,1307.8,2925.4,4337.3,5014.8,4900.7,4082.5,2648.6,1194.3,93.3,3.2,4.5,5.9,3.9,2,.7],
    [.7,.5,.1,.1,.4,1.2,6.9,282.8,1544.2,3532.6,5745,7449.6,8129.6,8000.1,6825.6,5178.8,3124.1,993.6,55.5,3.9,5.4,4.5,2.7,1.6],
    [.6,.4,.2,.5,.5,5.6,320.8,1744.3,4133.6,7000.8,9410.2,10885,11422.9,11155.9,9852.2,7598.5,4659.4,2199.6,564.3,29.9,3.5,2.4,1.2,.9],
    [.9,.6,.3,.5,.8,104,897.3,2695.1,5217.4,7967.1,10263.8,11592,12161.9,11777.8,10500.2,8498.3,5436.5,2936.8,1121.1,203,7.3,2,1.9,1.3],
    [.6,.5,.2,.2,2.9,197.6,1113.8,2991.9,5568.9,8396.6,10551.1,11847.1,12338.1,12010.8,10804.6,8731.9,5830.9,3304.5,1428.1,346.6,21.4,2.3,1.7,1.4],
    [.7,.5,.3,.2,.6,123.2,919.5,2679.1,5161.1,7906,10275.9,11568.7,12082.6,11609.1,10548.4,8529.9,5658.5,3165.8,1341,303.6,10.2,1.5,1.2,1.1],
    [.3,.2,.2,.2,.1,13.6,437.3,1845.2,4082.6,6756.3,9004.8,10312.8,10682.5,10351.7,9278.6,7289.6,4504.6,2338.7,748,81.5,2.2,1.8,1.2,.7],
    [.2,.1,.1,0,0,.3,61,952,2836.1,5253.1,7410.4,8799.5,9180,8626.3,7359.8,5407.5,2905.2,1042,95.3,3.2,3.2,2.4,1.1,.7],
    [.5,.3,.2,0,.3,.7,.7,142.4,1136.4,2936.9,4770,5804.5,6137.9,5626.6,4492,2820.4,934.1,73.1,2.2,3,3.7,2.6,1.7,1.2],
    [1.8,.8,.4,.6,.9,1.3,2.2,3.6,186.7,1074.1,2439.7,3592.6,3836.8,3415.4,2191.3,800.7,67.1,5.4,6.5,7.3,7.5,8.8,4.8,2.4],
    [1,.5,.4,.3,.6,1.1,3,4.5,8.5,241.5,1178.9,2408.3,2839.6,2455.9,1346.3,240,10.3,4.4,6.7,9.5,9.1,8.1,4.9,1.8],
  ],
  solarRefCapacity: 22,

  fleet: [
    { type: "Bus met laadbak", n: 32, mwh: 558 },   // 48 kWh/dag/auto × 7d/wk × 52
    { type: "Combi Afzet", n: 3, mwh: 299 },         // 384 kWh/dag/auto × 5d/wk × 52
    { type: "Combi KV-D/E LZV", n: 13, mwh: 1945 },  // 575 kWh/dag/auto × 5d/wk × 52
    { type: "Trekker", n: 6, mwh: 1047 },             // 559 kWh/dag/auto × 6d/wk × 52
    { type: "Trekker 6x2 VLA", n: 44, mwh: 8600 },   // 626 kWh/dag/auto × 6d/wk × 52
    { type: "Trekker Bulk", n: 31, mwh: 5410 },       // 559 kWh/dag/auto × 6d/wk × 52
    { type: "Trekker DC", n: 3, mwh: 523 },           // 559 kWh/dag/auto × 6d/wk × 52
    { type: "Trekker LWD", n: 7, mwh: 782 },          // 430 kWh/dag/auto × 5d/wk × 52
  ],

  chargingProfile: [.69,.59,.53,.91,1.12,1.17,.82,.47,.34,.30,.26,.26,.30,.34,.43,.60,1.03,1.55,2.35,2.58,2.45,2.03,1.60,1.28],
  seasonalFactors: [.95,.93,.97,.98,1,.95,.90,.92,1.02,1.08,1.12,1.18],

  defaults: {
    pv: 22, bE: 25, bP: 21.5,
    eff: 88, dod: 90, buP: 2.5,
    gMax: 0.85, dem: 19164, deg: 2, // 63,111 kWh/dag × 304 gewogen dagen ≈ 19,164 MWh/j
  },

  scenarios: [
    { n: 'Presentatie', d: 'Instellingen uit de Simon Loos presentatie', v: { pv:22,bE:25,bP:21.5,eff:88,dod:90,buP:2.5,gMax:0.85,dem:19164,deg:2,projYear:1 } },
    { n: '14 MWp', d: 'Alternatief PV-scenario (presentatie slide)', v: { pv:14,bE:25,bP:21.5,eff:88,dod:90,buP:2.5,gMax:0.85,dem:19164,deg:2,projYear:1 } },
    { n: 'Geen Backup', d: 'Wat als er geen noodgenerator is?', v: { pv:22,bE:25,bP:21.5,eff:88,dod:90,buP:0,gMax:0.85,dem:19164,deg:2,projYear:1 } },
    { n: 'Grote BESS', d: 'Dubbele batterijcapaciteit', v: { pv:22,bE:50,bP:21.5,eff:88,dod:90,buP:2.5,gMax:0.85,dem:19164,deg:2,projYear:1 } },
    { n: 'Jaar 10', d: 'Systeem na 10 jaar degradatie (2%/j)', v: { pv:22,bE:25,bP:21.5,eff:88,dod:90,buP:2.5,gMax:0.85,dem:19164,deg:2,projYear:10 } },
    { n: 'Jaar 20', d: 'Einde levensduur (20 jaar, 2%/j)', v: { pv:22,bE:25,bP:21.5,eff:88,dod:90,buP:2.5,gMax:0.85,dem:19164,deg:2,projYear:20 } },
  ],

  docs: [
    { cat: "BESS", params: [
      { l: "Round-trip Efficiency", d: "88%", r: "82-95%", s: "BloombergNEF BESS Cost Survey 2024; NREL 'Grid-Scale Battery Storage' (2024). LFP systemen: 85-92%.", n: "LFP (Lithium Iron Phosphate) standaard voor utility-scale." },
      { l: "Max C-rate", d: "0.86C", r: "0.5-2.0C", s: "21.5 MW / 25 MWh = 0.86C vanuit presentatie.", n: "Hogere C-rate = sneller maar meer degradatie." },
      { l: "Depth of Discharge", d: "90%", r: "80-95%", s: "NREL Utility-Scale Battery Storage Factsheet (2024). LFP: 80-95% DoD.", n: "90% DoD → bruikbaar: 22.5 MWh van 25 MWh totaal." },
      { l: "Degradatie", d: "2%/j", r: "1-4%/j", s: "NREL (2024), Lazard LCOS v8. LFP: 1.5-3% bij 1 cyclus/dag.", n: "Na 10 jaar: ~82% restcapaciteit." },
    ]},
    { cat: "Backup Generator", params: [
      { l: "Rendement", d: "40%", r: "35-48%", s: "Diesel genset: 35-42% (MAN/Caterpillar 2024).", n: "Type nog te bepalen." },
      { l: "Brandstofkosten", d: "€0.20/kWh_e", r: "€0.12-0.40", s: "Diesel €0.15-0.20. HVO €0.25-0.35.", n: "Relevant voor business case." },
    ]},
    { cat: "Grid", params: [
      { l: "Capaciteit", d: "0.85 MW", r: "0-5 MW", s: "Presentatie slide 4: 0.85 MW max aansluiting.", n: "Symmetrisch (import+export)." },
      { l: "Import tarief", d: "€0.12/kWh", r: "€0.06-0.20", s: "APX Day-ahead NL 2024 (ENTSO-E).", n: "Excl. capaciteitstarief." },
      { l: "Export tarief", d: "€0.06/kWh", r: "€0.02-0.12", s: "APX spot minus profielverlies (TenneT 2024).", n: "Bij SDE++ kan dit hoger uitvallen." },
    ]},
    { cat: "PV", params: [
      { l: "Capaciteit", d: "22 MWp", r: "14-30 MWp", s: "Email Youp (ELIX): 22 MWp.", n: "Gebruik slider om alternatieven te testen." },
      { l: "CAPEX", d: "€550/kWp", r: "€400-750", s: "Utility-scale grondgebonden NL: €450-650 (SolarPower Europe 2025).", n: "Incl. modules, omvormers, constructie." },
    ]},
    { cat: "Laadprofiel (synthetisch)", params: [
      { l: "Dagprofiel", d: "Twee-pieks", r: "—", s: "TNO 'Charging infrastructure for electric trucks' (2023). CE Delft (2024).", n: "Nachtvloot retour 03-05h, dagvloot retour 17-20h." },
      { l: "Seizoensfactor", d: "0.90-1.18", r: "—", s: "TLN seizoensdata logistiek sector.", n: "Q4 +12-18% (kerstdrukte), zomer -5-10%." },
    ]},
  ],

  guide: [
    {
      title: "Wat is dit model?",
      icon: "🏗️",
      body: `Dit is een **simulatiemodel** voor het toekomstige energiepark in Wognum. Het berekent hoeveel energie er per uur wordt opgewekt door zonnepanelen, hoeveel er nodig is om elektrische vrachtwagens op te laden, en hoe een grote batterij, het stroomnet en een noodgenerator samenwerken om vraag en aanbod te matchen.

Het model gebruikt **echte zonnedata** en een **geschat laadprofiel** op basis van wetenschappelijk onderzoek van TNO en CE Delft.`
    },
    {
      title: "De KPI-kaarten",
      icon: "📊",
      items: [
        { term: "☀️ PV Productie", def: "Hoeveel stroom alle zonnepanelen samen per jaar opwekken, in MWh." },
        { term: "🔌 Laadvraag", def: "Hoeveel stroom alle vrachtwagens samen per jaar nodig hebben." },
        { term: "✅ Zelfvoorziening", def: "Welk percentage van de laadvraag direct door PV + batterij wordt geleverd." },
        { term: "⚡ Grid Import", def: "Hoeveel stroom er van het openbare net moet worden ingekocht." },
        { term: "🏭 Backup", def: "Hoeveel stroom de noodgenerator moet produceren." },
        { term: "⚠️ Curtailed", def: "Hoeveel zonnestroom verloren gaat." },
      ]
    },
    {
      title: "Hoe werkt de berekening?",
      icon: "⚡",
      body: `Elk uur van het jaar berekent het model de energiebalans via het **dispatch-algoritme** (merit-order):

**Bij overschot PV:**
1. Zonnestroom → vloot (directe levering)
2. Surplus → batterij laden
3. Surplus → grid export
4. Rest → curtailment

**Bij tekort:**
1. Alle PV → vloot
2. Batterij levert tekort
3. Grid import vult aan
4. Backup generator als noodoplossing`
    },
  ],

  neutralNames: {
    company: 'Charging Solutions',
    client: 'de klant',
    projectName: 'Energy Park',
  },
};
